import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ObjectRelationFilterData {
    relationTypes: DropdownOptionIntegerId;
    primaryTargetObjects: Array<DropdownOptionIntegerId>;    
    foreignTargetObjects: Array<DropdownOptionIntegerId>;
    relationshipOwners: Array<DropdownOptionIntegerId>;
}